// EIA 'Average Price (Cents/kilowatthour) by State by Provider, 1990–2020',
// Total Electric Industry, Residential column, 2005–2020 window.
// Source: https://www.eia.gov/electricity/data/state/avgprice_annual.xlsx
// (extracted 2026-08-20, dependency-free XML parse — see PR). Static on purpose:
// the tool makes no runtime API calls. 2021+ continues in the funnel's shared
// ratesByState (EIA Table 5.6.B December YTD).
//
// Powers the chart's deep-history bars and the ledger's history rows (see
// engine/backcastDeepHistory), plus the "Recent pace" scenario's 2015→latest
// CAGR (engine/scenarios). The forward projection does not replay this series.

export const historicalRatesByState: Record<string, { rate: number; year: number }[]> = {
  AK: [
    { rate: 13.3, year: 2005 },
    { rate: 14.83, year: 2006 },
    { rate: 15.18, year: 2007 },
    { rate: 16.56, year: 2008 },
    { rate: 17.14, year: 2009 },
    { rate: 16.26, year: 2010 },
    { rate: 17.62, year: 2011 },
    { rate: 17.88, year: 2012 },
    { rate: 18.12, year: 2013 },
    { rate: 19.14, year: 2014 },
    { rate: 19.83, year: 2015 },
    { rate: 20.3, year: 2016 },
    { rate: 21.27, year: 2017 },
    { rate: 21.94, year: 2018 },
    { rate: 22.92, year: 2019 },
    { rate: 22.57, year: 2020 },
  ],
  AL: [
    { rate: 8, year: 2005 },
    { rate: 8.75, year: 2006 },
    { rate: 9.32, year: 2007 },
    { rate: 10.4, year: 2008 },
    { rate: 10.66, year: 2009 },
    { rate: 10.67, year: 2010 },
    { rate: 11.09, year: 2011 },
    { rate: 11.4, year: 2012 },
    { rate: 11.26, year: 2013 },
    { rate: 11.48, year: 2014 },
    { rate: 11.7, year: 2015 },
    { rate: 11.99, year: 2016 },
    { rate: 12.55, year: 2017 },
    { rate: 12.18, year: 2018 },
    { rate: 12.53, year: 2019 },
    { rate: 12.58, year: 2020 },
  ],
  AR: [
    { rate: 8, year: 2005 },
    { rate: 8.85, year: 2006 },
    { rate: 8.73, year: 2007 },
    { rate: 9.27, year: 2008 },
    { rate: 9.14, year: 2009 },
    { rate: 8.86, year: 2010 },
    { rate: 9.02, year: 2011 },
    { rate: 9.3, year: 2012 },
    { rate: 9.59, year: 2013 },
    { rate: 9.51, year: 2014 },
    { rate: 9.82, year: 2015 },
    { rate: 9.92, year: 2016 },
    { rate: 10.28, year: 2017 },
    { rate: 9.81, year: 2018 },
    { rate: 9.8, year: 2019 },
    { rate: 10.41, year: 2020 },
  ],
  AZ: [
    { rate: 8.86, year: 2005 },
    { rate: 9.4, year: 2006 },
    { rate: 9.66, year: 2007 },
    { rate: 10.27, year: 2008 },
    { rate: 10.73, year: 2009 },
    { rate: 10.97, year: 2010 },
    { rate: 11.08, year: 2011 },
    { rate: 11.29, year: 2012 },
    { rate: 11.71, year: 2013 },
    { rate: 11.9, year: 2014 },
    { rate: 12.13, year: 2015 },
    { rate: 12.15, year: 2016 },
    { rate: 12.44, year: 2017 },
    { rate: 12.77, year: 2018 },
    { rate: 12.43, year: 2019 },
    { rate: 12.27, year: 2020 },
  ],
  CA: [
    { rate: 12.51, year: 2005 },
    { rate: 14.33, year: 2006 },
    { rate: 14.42, year: 2007 },
    { rate: 13.81, year: 2008 },
    { rate: 14.74, year: 2009 },
    { rate: 14.75, year: 2010 },
    { rate: 14.78, year: 2011 },
    { rate: 15.34, year: 2012 },
    { rate: 16.23, year: 2013 },
    { rate: 16.25, year: 2014 },
    { rate: 16.99, year: 2015 },
    { rate: 17.39, year: 2016 },
    { rate: 18.31, year: 2017 },
    { rate: 18.84, year: 2018 },
    { rate: 19.15, year: 2019 },
    { rate: 20.45, year: 2020 },
  ],
  CO: [
    { rate: 9.06, year: 2005 },
    { rate: 9.02, year: 2006 },
    { rate: 9.25, year: 2007 },
    { rate: 10.13, year: 2008 },
    { rate: 10, year: 2009 },
    { rate: 11.04, year: 2010 },
    { rate: 11.27, year: 2011 },
    { rate: 11.46, year: 2012 },
    { rate: 11.93, year: 2013 },
    { rate: 12.18, year: 2014 },
    { rate: 12.12, year: 2015 },
    { rate: 12.07, year: 2016 },
    { rate: 12.17, year: 2017 },
    { rate: 12.15, year: 2018 },
    { rate: 12.18, year: 2019 },
    { rate: 12.36, year: 2020 },
  ],
  CT: [
    { rate: 13.64, year: 2005 },
    { rate: 16.86, year: 2006 },
    { rate: 19.11, year: 2007 },
    { rate: 19.54, year: 2008 },
    { rate: 20.33, year: 2009 },
    { rate: 19.25, year: 2010 },
    { rate: 18.11, year: 2011 },
    { rate: 17.34, year: 2012 },
    { rate: 17.55, year: 2013 },
    { rate: 19.75, year: 2014 },
    { rate: 20.94, year: 2015 },
    { rate: 20.01, year: 2016 },
    { rate: 20.29, year: 2017 },
    { rate: 21.2, year: 2018 },
    { rate: 21.87, year: 2019 },
    { rate: 22.71, year: 2020 },
  ],
  DC: [
    { rate: 9.1, year: 2005 },
    { rate: 9.88, year: 2006 },
    { rate: 11.18, year: 2007 },
    { rate: 12.78, year: 2008 },
    { rate: 13.73, year: 2009 },
    { rate: 14.01, year: 2010 },
    { rate: 13.4, year: 2011 },
    { rate: 12.28, year: 2012 },
    { rate: 12.57, year: 2013 },
    { rate: 12.74, year: 2014 },
    { rate: 12.99, year: 2015 },
    { rate: 12.29, year: 2016 },
    { rate: 12.94, year: 2017 },
    { rate: 12.84, year: 2018 },
    { rate: 12.98, year: 2019 },
    { rate: 12.63, year: 2020 },
  ],
  DE: [
    { rate: 9.01, year: 2005 },
    { rate: 11.85, year: 2006 },
    { rate: 13.16, year: 2007 },
    { rate: 13.93, year: 2008 },
    { rate: 14.07, year: 2009 },
    { rate: 13.8, year: 2010 },
    { rate: 13.7, year: 2011 },
    { rate: 13.58, year: 2012 },
    { rate: 12.95, year: 2013 },
    { rate: 13.29, year: 2014 },
    { rate: 13.42, year: 2015 },
    { rate: 13.42, year: 2016 },
    { rate: 13.35, year: 2017 },
    { rate: 12.53, year: 2018 },
    { rate: 12.55, year: 2019 },
    { rate: 12.56, year: 2020 },
  ],
  FL: [
    { rate: 9.62, year: 2005 },
    { rate: 11.33, year: 2006 },
    { rate: 11.22, year: 2007 },
    { rate: 11.65, year: 2008 },
    { rate: 12.39, year: 2009 },
    { rate: 11.44, year: 2010 },
    { rate: 11.51, year: 2011 },
    { rate: 11.42, year: 2012 },
    { rate: 11.27, year: 2013 },
    { rate: 11.89, year: 2014 },
    { rate: 11.58, year: 2015 },
    { rate: 10.98, year: 2016 },
    { rate: 11.61, year: 2017 },
    { rate: 11.54, year: 2018 },
    { rate: 11.7, year: 2019 },
    { rate: 11.27, year: 2020 },
  ],
  GA: [
    { rate: 8.64, year: 2005 },
    { rate: 8.91, year: 2006 },
    { rate: 9.1, year: 2007 },
    { rate: 9.93, year: 2008 },
    { rate: 10.13, year: 2009 },
    { rate: 10.07, year: 2010 },
    { rate: 11.05, year: 2011 },
    { rate: 11.17, year: 2012 },
    { rate: 11.46, year: 2013 },
    { rate: 11.65, year: 2014 },
    { rate: 11.54, year: 2015 },
    { rate: 11.5, year: 2016 },
    { rate: 11.9, year: 2017 },
    { rate: 11.47, year: 2018 },
    { rate: 11.76, year: 2019 },
    { rate: 12.02, year: 2020 },
  ],
  HI: [
    { rate: 20.7, year: 2005 },
    { rate: 23.35, year: 2006 },
    { rate: 24.12, year: 2007 },
    { rate: 32.5, year: 2008 },
    { rate: 24.2, year: 2009 },
    { rate: 28.1, year: 2010 },
    { rate: 34.68, year: 2011 },
    { rate: 37.34, year: 2012 },
    { rate: 36.98, year: 2013 },
    { rate: 37.04, year: 2014 },
    { rate: 29.6, year: 2015 },
    { rate: 27.47, year: 2016 },
    { rate: 29.5, year: 2017 },
    { rate: 32.47, year: 2018 },
    { rate: 32.06, year: 2019 },
    { rate: 30.28, year: 2020 },
  ],
  IA: [
    { rate: 9.27, year: 2005 },
    { rate: 9.63, year: 2006 },
    { rate: 9.45, year: 2007 },
    { rate: 9.49, year: 2008 },
    { rate: 9.99, year: 2009 },
    { rate: 10.42, year: 2010 },
    { rate: 10.46, year: 2011 },
    { rate: 10.82, year: 2012 },
    { rate: 11.04, year: 2013 },
    { rate: 11.16, year: 2014 },
    { rate: 11.63, year: 2015 },
    { rate: 11.94, year: 2016 },
    { rate: 12.34, year: 2017 },
    { rate: 12.24, year: 2018 },
    { rate: 12.46, year: 2019 },
    { rate: 12.46, year: 2020 },
  ],
  ID: [
    { rate: 6.29, year: 2005 },
    { rate: 6.21, year: 2006 },
    { rate: 6.36, year: 2007 },
    { rate: 6.99, year: 2008 },
    { rate: 7.8, year: 2009 },
    { rate: 7.99, year: 2010 },
    { rate: 7.87, year: 2011 },
    { rate: 8.67, year: 2012 },
    { rate: 9.32, year: 2013 },
    { rate: 9.72, year: 2014 },
    { rate: 9.93, year: 2015 },
    { rate: 9.95, year: 2016 },
    { rate: 10.04, year: 2017 },
    { rate: 10.15, year: 2018 },
    { rate: 9.89, year: 2019 },
    { rate: 9.95, year: 2020 },
  ],
  IL: [
    { rate: 8.34, year: 2005 },
    { rate: 8.42, year: 2006 },
    { rate: 10.12, year: 2007 },
    { rate: 11.07, year: 2008 },
    { rate: 11.27, year: 2009 },
    { rate: 11.52, year: 2010 },
    { rate: 11.78, year: 2011 },
    { rate: 11.38, year: 2012 },
    { rate: 10.63, year: 2013 },
    { rate: 11.91, year: 2014 },
    { rate: 12.5, year: 2015 },
    { rate: 12.54, year: 2016 },
    { rate: 12.95, year: 2017 },
    { rate: 12.77, year: 2018 },
    { rate: 13.03, year: 2019 },
    { rate: 13.04, year: 2020 },
  ],
  IN: [
    { rate: 7.5, year: 2005 },
    { rate: 8.22, year: 2006 },
    { rate: 8.26, year: 2007 },
    { rate: 8.87, year: 2008 },
    { rate: 9.5, year: 2009 },
    { rate: 9.56, year: 2010 },
    { rate: 10.06, year: 2011 },
    { rate: 10.53, year: 2012 },
    { rate: 10.99, year: 2013 },
    { rate: 11.46, year: 2014 },
    { rate: 11.57, year: 2015 },
    { rate: 11.79, year: 2016 },
    { rate: 12.29, year: 2017 },
    { rate: 12.26, year: 2018 },
    { rate: 12.58, year: 2019 },
    { rate: 12.83, year: 2020 },
  ],
  KS: [
    { rate: 7.9, year: 2005 },
    { rate: 8.25, year: 2006 },
    { rate: 8.19, year: 2007 },
    { rate: 8.89, year: 2008 },
    { rate: 9.53, year: 2009 },
    { rate: 10.03, year: 2010 },
    { rate: 10.65, year: 2011 },
    { rate: 11.24, year: 2012 },
    { rate: 11.64, year: 2013 },
    { rate: 12.17, year: 2014 },
    { rate: 12.34, year: 2015 },
    { rate: 13.06, year: 2016 },
    { rate: 13.31, year: 2017 },
    { rate: 13.35, year: 2018 },
    { rate: 12.71, year: 2019 },
    { rate: 12.85, year: 2020 },
  ],
  KY: [
    { rate: 6.57, year: 2005 },
    { rate: 7.02, year: 2006 },
    { rate: 7.34, year: 2007 },
    { rate: 7.94, year: 2008 },
    { rate: 8.37, year: 2009 },
    { rate: 8.57, year: 2010 },
    { rate: 9.2, year: 2011 },
    { rate: 9.43, year: 2012 },
    { rate: 9.79, year: 2013 },
    { rate: 10.16, year: 2014 },
    { rate: 10.24, year: 2015 },
    { rate: 10.49, year: 2016 },
    { rate: 10.85, year: 2017 },
    { rate: 10.6, year: 2018 },
    { rate: 10.8, year: 2019 },
    { rate: 10.87, year: 2020 },
  ],
  LA: [
    { rate: 8.87, year: 2005 },
    { rate: 9.14, year: 2006 },
    { rate: 9.37, year: 2007 },
    { rate: 10.28, year: 2008 },
    { rate: 8.1, year: 2009 },
    { rate: 8.98, year: 2010 },
    { rate: 8.96, year: 2011 },
    { rate: 8.37, year: 2012 },
    { rate: 9.43, year: 2013 },
    { rate: 9.57, year: 2014 },
    { rate: 9.33, year: 2015 },
    { rate: 9.34, year: 2016 },
    { rate: 9.74, year: 2017 },
    { rate: 9.59, year: 2018 },
    { rate: 9.8, year: 2019 },
    { rate: 9.67, year: 2020 },
  ],
  MA: [
    { rate: 13.44, year: 2005 },
    { rate: 16.6, year: 2006 },
    { rate: 16.23, year: 2007 },
    { rate: 17.56, year: 2008 },
    { rate: 16.87, year: 2009 },
    { rate: 14.59, year: 2010 },
    { rate: 14.67, year: 2011 },
    { rate: 14.91, year: 2012 },
    { rate: 15.83, year: 2013 },
    { rate: 17.39, year: 2014 },
    { rate: 19.83, year: 2015 },
    { rate: 19, year: 2016 },
    { rate: 20.06, year: 2017 },
    { rate: 21.61, year: 2018 },
    { rate: 21.92, year: 2019 },
    { rate: 21.97, year: 2020 },
  ],
  MD: [
    { rate: 8.46, year: 2005 },
    { rate: 9.71, year: 2006 },
    { rate: 11.89, year: 2007 },
    { rate: 13.84, year: 2008 },
    { rate: 14.98, year: 2009 },
    { rate: 14.32, year: 2010 },
    { rate: 13.31, year: 2011 },
    { rate: 12.84, year: 2012 },
    { rate: 13.25, year: 2013 },
    { rate: 13.63, year: 2014 },
    { rate: 13.82, year: 2015 },
    { rate: 14.23, year: 2016 },
    { rate: 13.96, year: 2017 },
    { rate: 13.3, year: 2018 },
    { rate: 13.12, year: 2019 },
    { rate: 13.01, year: 2020 },
  ],
  ME: [
    { rate: 13.23, year: 2005 },
    { rate: 13.8, year: 2006 },
    { rate: 16.52, year: 2007 },
    { rate: 16.24, year: 2008 },
    { rate: 15.64, year: 2009 },
    { rate: 15.72, year: 2010 },
    { rate: 15.38, year: 2011 },
    { rate: 14.66, year: 2012 },
    { rate: 14.35, year: 2013 },
    { rate: 15.27, year: 2014 },
    { rate: 15.61, year: 2015 },
    { rate: 15.83, year: 2016 },
    { rate: 15.97, year: 2017 },
    { rate: 16.84, year: 2018 },
    { rate: 17.89, year: 2019 },
    { rate: 16.81, year: 2020 },
  ],
  MI: [
    { rate: 8.4, year: 2005 },
    { rate: 9.77, year: 2006 },
    { rate: 10.21, year: 2007 },
    { rate: 10.75, year: 2008 },
    { rate: 11.6, year: 2009 },
    { rate: 12.46, year: 2010 },
    { rate: 13.27, year: 2011 },
    { rate: 14.13, year: 2012 },
    { rate: 14.59, year: 2013 },
    { rate: 14.46, year: 2014 },
    { rate: 14.42, year: 2015 },
    { rate: 15.22, year: 2016 },
    { rate: 15.4, year: 2017 },
    { rate: 15.45, year: 2018 },
    { rate: 15.74, year: 2019 },
    { rate: 16.26, year: 2020 },
  ],
  MN: [
    { rate: 8.28, year: 2005 },
    { rate: 8.7, year: 2006 },
    { rate: 9.18, year: 2007 },
    { rate: 9.74, year: 2008 },
    { rate: 10.04, year: 2009 },
    { rate: 10.59, year: 2010 },
    { rate: 10.96, year: 2011 },
    { rate: 11.35, year: 2012 },
    { rate: 11.81, year: 2013 },
    { rate: 12.01, year: 2014 },
    { rate: 12.12, year: 2015 },
    { rate: 12.67, year: 2016 },
    { rate: 13.04, year: 2017 },
    { rate: 13.14, year: 2018 },
    { rate: 13.04, year: 2019 },
    { rate: 13.17, year: 2020 },
  ],
  MO: [
    { rate: 7.08, year: 2005 },
    { rate: 7.44, year: 2006 },
    { rate: 7.69, year: 2007 },
    { rate: 8, year: 2008 },
    { rate: 8.54, year: 2009 },
    { rate: 9.08, year: 2010 },
    { rate: 9.75, year: 2011 },
    { rate: 10.17, year: 2012 },
    { rate: 10.6, year: 2013 },
    { rate: 10.64, year: 2014 },
    { rate: 11.21, year: 2015 },
    { rate: 11.21, year: 2016 },
    { rate: 11.63, year: 2017 },
    { rate: 11.34, year: 2018 },
    { rate: 11.14, year: 2019 },
    { rate: 11.22, year: 2020 },
  ],
  MS: [
    { rate: 8.71, year: 2005 },
    { rate: 9.66, year: 2006 },
    { rate: 9.36, year: 2007 },
    { rate: 10.39, year: 2008 },
    { rate: 10.22, year: 2009 },
    { rate: 9.87, year: 2010 },
    { rate: 10.17, year: 2011 },
    { rate: 10.26, year: 2012 },
    { rate: 10.78, year: 2013 },
    { rate: 11.32, year: 2014 },
    { rate: 11.27, year: 2015 },
    { rate: 10.47, year: 2016 },
    { rate: 11.08, year: 2017 },
    { rate: 11.12, year: 2018 },
    { rate: 11.27, year: 2019 },
    { rate: 11.17, year: 2020 },
  ],
  MT: [
    { rate: 8.1, year: 2005 },
    { rate: 8.28, year: 2006 },
    { rate: 8.77, year: 2007 },
    { rate: 9.13, year: 2008 },
    { rate: 8.94, year: 2009 },
    { rate: 9.16, year: 2010 },
    { rate: 9.75, year: 2011 },
    { rate: 10.08, year: 2012 },
    { rate: 10.33, year: 2013 },
    { rate: 10.18, year: 2014 },
    { rate: 10.88, year: 2015 },
    { rate: 10.94, year: 2016 },
    { rate: 10.95, year: 2017 },
    { rate: 10.96, year: 2018 },
    { rate: 11.13, year: 2019 },
    { rate: 11.24, year: 2020 },
  ],
  NC: [
    { rate: 8.65, year: 2005 },
    { rate: 9.12, year: 2006 },
    { rate: 9.4, year: 2007 },
    { rate: 9.52, year: 2008 },
    { rate: 9.99, year: 2009 },
    { rate: 10.12, year: 2010 },
    { rate: 10.26, year: 2011 },
    { rate: 10.91, year: 2012 },
    { rate: 10.97, year: 2013 },
    { rate: 11.1, year: 2014 },
    { rate: 11.28, year: 2015 },
    { rate: 11.03, year: 2016 },
    { rate: 10.94, year: 2017 },
    { rate: 11.09, year: 2018 },
    { rate: 11.42, year: 2019 },
    { rate: 11.38, year: 2020 },
  ],
  ND: [
    { rate: 6.99, year: 2005 },
    { rate: 7.14, year: 2006 },
    { rate: 7.3, year: 2007 },
    { rate: 7.52, year: 2008 },
    { rate: 7.58, year: 2009 },
    { rate: 8.13, year: 2010 },
    { rate: 8.58, year: 2011 },
    { rate: 9.06, year: 2012 },
    { rate: 9.12, year: 2013 },
    { rate: 9.15, year: 2014 },
    { rate: 9.62, year: 2015 },
    { rate: 10.16, year: 2016 },
    { rate: 10.29, year: 2017 },
    { rate: 10.25, year: 2018 },
    { rate: 10.3, year: 2019 },
    { rate: 10.44, year: 2020 },
  ],
  NE: [
    { rate: 7.14, year: 2005 },
    { rate: 7.41, year: 2006 },
    { rate: 7.59, year: 2007 },
    { rate: 7.87, year: 2008 },
    { rate: 8.52, year: 2009 },
    { rate: 8.94, year: 2010 },
    { rate: 9.32, year: 2011 },
    { rate: 10.04, year: 2012 },
    { rate: 10.31, year: 2013 },
    { rate: 10.4, year: 2014 },
    { rate: 10.6, year: 2015 },
    { rate: 10.84, year: 2016 },
    { rate: 10.97, year: 2017 },
    { rate: 10.7, year: 2018 },
    { rate: 10.77, year: 2019 },
    { rate: 10.8, year: 2020 },
  ],
  NH: [
    { rate: 13.51, year: 2005 },
    { rate: 14.68, year: 2006 },
    { rate: 14.88, year: 2007 },
    { rate: 15.68, year: 2008 },
    { rate: 16.39, year: 2009 },
    { rate: 16.32, year: 2010 },
    { rate: 16.52, year: 2011 },
    { rate: 16.07, year: 2012 },
    { rate: 16.33, year: 2013 },
    { rate: 17.53, year: 2014 },
    { rate: 18.5, year: 2015 },
    { rate: 18.38, year: 2016 },
    { rate: 19.2, year: 2017 },
    { rate: 19.69, year: 2018 },
    { rate: 20.05, year: 2019 },
    { rate: 19.04, year: 2020 },
  ],
  NJ: [
    { rate: 11.74, year: 2005 },
    { rate: 12.84, year: 2006 },
    { rate: 14.14, year: 2007 },
    { rate: 15.66, year: 2008 },
    { rate: 16.31, year: 2009 },
    { rate: 16.57, year: 2010 },
    { rate: 16.23, year: 2011 },
    { rate: 15.78, year: 2012 },
    { rate: 15.73, year: 2013 },
    { rate: 15.78, year: 2014 },
    { rate: 15.81, year: 2015 },
    { rate: 15.72, year: 2016 },
    { rate: 15.65, year: 2017 },
    { rate: 15.41, year: 2018 },
    { rate: 15.85, year: 2019 },
    { rate: 16.03, year: 2020 },
  ],
  NM: [
    { rate: 9.13, year: 2005 },
    { rate: 9.06, year: 2006 },
    { rate: 9.12, year: 2007 },
    { rate: 10.01, year: 2008 },
    { rate: 10.02, year: 2009 },
    { rate: 10.52, year: 2010 },
    { rate: 11, year: 2011 },
    { rate: 11.38, year: 2012 },
    { rate: 11.68, year: 2013 },
    { rate: 12.28, year: 2014 },
    { rate: 12.47, year: 2015 },
    { rate: 12.03, year: 2016 },
    { rate: 12.88, year: 2017 },
    { rate: 12.68, year: 2018 },
    { rate: 12.51, year: 2019 },
    { rate: 12.94, year: 2020 },
  ],
  NV: [
    { rate: 10.2, year: 2005 },
    { rate: 11.08, year: 2006 },
    { rate: 11.82, year: 2007 },
    { rate: 11.93, year: 2008 },
    { rate: 12.86, year: 2009 },
    { rate: 12.36, year: 2010 },
    { rate: 11.61, year: 2011 },
    { rate: 11.83, year: 2012 },
    { rate: 11.89, year: 2013 },
    { rate: 12.93, year: 2014 },
    { rate: 12.76, year: 2015 },
    { rate: 11.41, year: 2016 },
    { rate: 11.99, year: 2017 },
    { rate: 11.85, year: 2018 },
    { rate: 12, year: 2019 },
    { rate: 11.34, year: 2020 },
  ],
  NY: [
    { rate: 15.72, year: 2005 },
    { rate: 16.89, year: 2006 },
    { rate: 17.1, year: 2007 },
    { rate: 18.31, year: 2008 },
    { rate: 17.5, year: 2009 },
    { rate: 18.74, year: 2010 },
    { rate: 18.26, year: 2011 },
    { rate: 17.62, year: 2012 },
    { rate: 18.79, year: 2013 },
    { rate: 20.07, year: 2014 },
    { rate: 18.54, year: 2015 },
    { rate: 17.58, year: 2016 },
    { rate: 18.03, year: 2017 },
    { rate: 18.52, year: 2018 },
    { rate: 17.94, year: 2019 },
    { rate: 18.36, year: 2020 },
  ],
  OH: [
    { rate: 8.51, year: 2005 },
    { rate: 9.34, year: 2006 },
    { rate: 9.57, year: 2007 },
    { rate: 10.06, year: 2008 },
    { rate: 10.67, year: 2009 },
    { rate: 11.31, year: 2010 },
    { rate: 11.42, year: 2011 },
    { rate: 11.76, year: 2012 },
    { rate: 12.01, year: 2013 },
    { rate: 12.5, year: 2014 },
    { rate: 12.8, year: 2015 },
    { rate: 12.47, year: 2016 },
    { rate: 12.63, year: 2017 },
    { rate: 12.56, year: 2018 },
    { rate: 12.38, year: 2019 },
    { rate: 12.29, year: 2020 },
  ],
  OK: [
    { rate: 7.95, year: 2005 },
    { rate: 8.55, year: 2006 },
    { rate: 8.58, year: 2007 },
    { rate: 9.09, year: 2008 },
    { rate: 8.49, year: 2009 },
    { rate: 9.14, year: 2010 },
    { rate: 9.47, year: 2011 },
    { rate: 9.51, year: 2012 },
    { rate: 9.67, year: 2013 },
    { rate: 10.03, year: 2014 },
    { rate: 10.14, year: 2015 },
    { rate: 10.2, year: 2016 },
    { rate: 10.61, year: 2017 },
    { rate: 10.3, year: 2018 },
    { rate: 10.21, year: 2019 },
    { rate: 10.12, year: 2020 },
  ],
  OR: [
    { rate: 7.25, year: 2005 },
    { rate: 7.48, year: 2006 },
    { rate: 8.19, year: 2007 },
    { rate: 8.49, year: 2008 },
    { rate: 8.68, year: 2009 },
    { rate: 8.87, year: 2010 },
    { rate: 9.54, year: 2011 },
    { rate: 9.8, year: 2012 },
    { rate: 9.9, year: 2013 },
    { rate: 10.47, year: 2014 },
    { rate: 10.66, year: 2015 },
    { rate: 10.66, year: 2016 },
    { rate: 10.66, year: 2017 },
    { rate: 10.98, year: 2018 },
    { rate: 11.01, year: 2019 },
    { rate: 11.17, year: 2020 },
  ],
  PA: [
    { rate: 9.86, year: 2005 },
    { rate: 10.35, year: 2006 },
    { rate: 10.95, year: 2007 },
    { rate: 11.35, year: 2008 },
    { rate: 11.65, year: 2009 },
    { rate: 12.7, year: 2010 },
    { rate: 13.26, year: 2011 },
    { rate: 12.75, year: 2012 },
    { rate: 12.79, year: 2013 },
    { rate: 13.32, year: 2014 },
    { rate: 13.64, year: 2015 },
    { rate: 13.86, year: 2016 },
    { rate: 14.23, year: 2017 },
    { rate: 13.89, year: 2018 },
    { rate: 13.8, year: 2019 },
    { rate: 13.58, year: 2020 },
  ],
  RI: [
    { rate: 13.04, year: 2005 },
    { rate: 15.12, year: 2006 },
    { rate: 14.05, year: 2007 },
    { rate: 17.45, year: 2008 },
    { rate: 15.6, year: 2009 },
    { rate: 15.92, year: 2010 },
    { rate: 14.33, year: 2011 },
    { rate: 14.4, year: 2012 },
    { rate: 15.2, year: 2013 },
    { rate: 17.17, year: 2014 },
    { rate: 19.29, year: 2015 },
    { rate: 18.62, year: 2016 },
    { rate: 18.32, year: 2017 },
    { rate: 20.55, year: 2018 },
    { rate: 21.73, year: 2019 },
    { rate: 22.01, year: 2020 },
  ],
  SC: [
    { rate: 8.67, year: 2005 },
    { rate: 9.03, year: 2006 },
    { rate: 9.19, year: 2007 },
    { rate: 9.89, year: 2008 },
    { rate: 10.44, year: 2009 },
    { rate: 10.5, year: 2010 },
    { rate: 11.05, year: 2011 },
    { rate: 11.77, year: 2012 },
    { rate: 11.99, year: 2013 },
    { rate: 12.45, year: 2014 },
    { rate: 12.57, year: 2015 },
    { rate: 12.65, year: 2016 },
    { rate: 13.02, year: 2017 },
    { rate: 12.44, year: 2018 },
    { rate: 12.99, year: 2019 },
    { rate: 12.78, year: 2020 },
  ],
  SD: [
    { rate: 7.77, year: 2005 },
    { rate: 7.83, year: 2006 },
    { rate: 8.07, year: 2007 },
    { rate: 8.27, year: 2008 },
    { rate: 8.49, year: 2009 },
    { rate: 8.97, year: 2010 },
    { rate: 9.35, year: 2011 },
    { rate: 10.07, year: 2012 },
    { rate: 10.26, year: 2013 },
    { rate: 10.47, year: 2014 },
    { rate: 11.08, year: 2015 },
    { rate: 11.47, year: 2016 },
    { rate: 11.77, year: 2017 },
    { rate: 11.59, year: 2018 },
    { rate: 11.55, year: 2019 },
    { rate: 11.75, year: 2020 },
  ],
  TN: [
    { rate: 6.98, year: 2005 },
    { rate: 7.75, year: 2006 },
    { rate: 7.84, year: 2007 },
    { rate: 8.91, year: 2008 },
    { rate: 9.32, year: 2009 },
    { rate: 9.23, year: 2010 },
    { rate: 9.98, year: 2011 },
    { rate: 10.1, year: 2012 },
    { rate: 9.98, year: 2013 },
    { rate: 10.32, year: 2014 },
    { rate: 10.3, year: 2015 },
    { rate: 10.41, year: 2016 },
    { rate: 10.72, year: 2017 },
    { rate: 10.71, year: 2018 },
    { rate: 10.87, year: 2019 },
    { rate: 10.76, year: 2020 },
  ],
  TX: [
    { rate: 10.93, year: 2005 },
    { rate: 12.86, year: 2006 },
    { rate: 12.34, year: 2007 },
    { rate: 13.03, year: 2008 },
    { rate: 12.38, year: 2009 },
    { rate: 11.6, year: 2010 },
    { rate: 11.08, year: 2011 },
    { rate: 10.98, year: 2012 },
    { rate: 11.35, year: 2013 },
    { rate: 11.86, year: 2014 },
    { rate: 11.56, year: 2015 },
    { rate: 10.99, year: 2016 },
    { rate: 11.01, year: 2017 },
    { rate: 11.2, year: 2018 },
    { rate: 11.76, year: 2019 },
    { rate: 11.71, year: 2020 },
  ],
  UT: [
    { rate: 7.52, year: 2005 },
    { rate: 7.59, year: 2006 },
    { rate: 8.15, year: 2007 },
    { rate: 8.26, year: 2008 },
    { rate: 8.48, year: 2009 },
    { rate: 8.71, year: 2010 },
    { rate: 8.96, year: 2011 },
    { rate: 9.93, year: 2012 },
    { rate: 10.37, year: 2013 },
    { rate: 10.65, year: 2014 },
    { rate: 10.88, year: 2015 },
    { rate: 11.02, year: 2016 },
    { rate: 10.95, year: 2017 },
    { rate: 10.41, year: 2018 },
    { rate: 10.4, year: 2019 },
    { rate: 10.44, year: 2020 },
  ],
  VA: [
    { rate: 8.16, year: 2005 },
    { rate: 8.49, year: 2006 },
    { rate: 8.74, year: 2007 },
    { rate: 9.62, year: 2008 },
    { rate: 10.61, year: 2009 },
    { rate: 10.45, year: 2010 },
    { rate: 10.64, year: 2011 },
    { rate: 11.08, year: 2012 },
    { rate: 10.84, year: 2013 },
    { rate: 11.1, year: 2014 },
    { rate: 11.37, year: 2015 },
    { rate: 11.36, year: 2016 },
    { rate: 11.55, year: 2017 },
    { rate: 11.73, year: 2018 },
    { rate: 12.07, year: 2019 },
    { rate: 12.03, year: 2020 },
  ],
  VT: [
    { rate: 12.96, year: 2005 },
    { rate: 13.39, year: 2006 },
    { rate: 14.15, year: 2007 },
    { rate: 14.48, year: 2008 },
    { rate: 14.9, year: 2009 },
    { rate: 15.57, year: 2010 },
    { rate: 16.26, year: 2011 },
    { rate: 17.01, year: 2012 },
    { rate: 17.14, year: 2013 },
    { rate: 17.47, year: 2014 },
    { rate: 17.09, year: 2015 },
    { rate: 17.37, year: 2016 },
    { rate: 17.68, year: 2017 },
    { rate: 18.02, year: 2018 },
    { rate: 17.71, year: 2019 },
    { rate: 19.54, year: 2020 },
  ],
  WA: [
    { rate: 6.54, year: 2005 },
    { rate: 6.82, year: 2006 },
    { rate: 7.26, year: 2007 },
    { rate: 7.54, year: 2008 },
    { rate: 7.67, year: 2009 },
    { rate: 8.04, year: 2010 },
    { rate: 8.28, year: 2011 },
    { rate: 8.53, year: 2012 },
    { rate: 8.7, year: 2013 },
    { rate: 8.67, year: 2014 },
    { rate: 9.09, year: 2015 },
    { rate: 9.48, year: 2016 },
    { rate: 9.66, year: 2017 },
    { rate: 9.75, year: 2018 },
    { rate: 9.71, year: 2019 },
    { rate: 9.87, year: 2020 },
  ],
  WI: [
    { rate: 9.66, year: 2005 },
    { rate: 10.51, year: 2006 },
    { rate: 10.87, year: 2007 },
    { rate: 11.51, year: 2008 },
    { rate: 11.94, year: 2009 },
    { rate: 12.65, year: 2010 },
    { rate: 13.02, year: 2011 },
    { rate: 13.19, year: 2012 },
    { rate: 13.55, year: 2013 },
    { rate: 13.67, year: 2014 },
    { rate: 14.11, year: 2015 },
    { rate: 14.07, year: 2016 },
    { rate: 14.35, year: 2017 },
    { rate: 14.02, year: 2018 },
    { rate: 14.18, year: 2019 },
    { rate: 14.32, year: 2020 },
  ],
  WV: [
    { rate: 6.21, year: 2005 },
    { rate: 6.35, year: 2006 },
    { rate: 6.73, year: 2007 },
    { rate: 7.06, year: 2008 },
    { rate: 7.9, year: 2009 },
    { rate: 8.79, year: 2010 },
    { rate: 9.39, year: 2011 },
    { rate: 9.85, year: 2012 },
    { rate: 9.52, year: 2013 },
    { rate: 9.34, year: 2014 },
    { rate: 10.08, year: 2015 },
    { rate: 11.44, year: 2016 },
    { rate: 11.63, year: 2017 },
    { rate: 11.18, year: 2018 },
    { rate: 11.25, year: 2019 },
    { rate: 11.8, year: 2020 },
  ],
  WY: [
    { rate: 7.48, year: 2005 },
    { rate: 7.75, year: 2006 },
    { rate: 7.75, year: 2007 },
    { rate: 8.21, year: 2008 },
    { rate: 8.58, year: 2009 },
    { rate: 8.77, year: 2010 },
    { rate: 9.11, year: 2011 },
    { rate: 9.85, year: 2012 },
    { rate: 10.16, year: 2013 },
    { rate: 10.5, year: 2014 },
    { rate: 10.97, year: 2015 },
    { rate: 11.13, year: 2016 },
    { rate: 11.37, year: 2017 },
    { rate: 11.29, year: 2018 },
    { rate: 11.18, year: 2019 },
    { rate: 11.11, year: 2020 },
  ],
};
